(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heyhunger-product-pdp"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hh-wireframe-pdp')){
  customElements.define('hh-wireframe-pdp', class extends HTMLElement{
    connectedCallback(){
      if(this.dataset.ready) return;
      this.dataset.ready = 'true';

      const methods = [...this.querySelectorAll('[data-cook-method]')];
      methods.forEach(method => method.addEventListener('toggle', () => {
        if(method.open) methods.forEach(other => { if(other !== method) other.open = false; });
      }));
      this.querySelectorAll('[data-open-cook]').forEach(link => {
        link.addEventListener('click', event => {
          event.preventDefault();
          const method = methods.find(item => item.dataset.cookMethod === link.dataset.openCook);
          if(!method) return;
          methods.forEach(item => { item.open = item === method; });
          method.closest('.hh-heat').scrollIntoView({behavior:'smooth', block:'start'});
          method.querySelector('summary').focus({preventScroll:true});
        });
      });
      this.querySelectorAll('[data-open-direct]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        const direct = this.querySelector('.hh-direct-order');
        if(!direct) return;
        direct.open = true;
        direct.scrollIntoView({behavior:'smooth', block:'center'});
        direct.querySelector('summary').focus({preventScroll:true});
      }));
      const qty = this.querySelector('input[name="quantity"]');
      this.querySelectorAll('[data-qty]').forEach(btn => {
        btn.addEventListener('click', () => {
          const next = Math.max(1, (parseInt(qty?.value || '1', 10) || 1) + Number(btn.dataset.qty));
          if(qty) qty.value = String(next);
        });
      });

      const select = this.querySelector('select[name="id"]');
      const price = this.querySelector('[data-price]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if(price) price.textContent = option.dataset.price;
        this.querySelectorAll('[data-add]').forEach(button => {
          const available = option.dataset.available === 'true';
          button.disabled = !available;
          button.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
        });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        history.replaceState({}, '', url);
      });

      const stage = this.querySelector('[data-gallery-stage]');
      const stageImg = stage?.querySelector(':scope > img');
      const packageFloat = stage?.querySelector('.hh-package-float');
      this.querySelectorAll('[data-gallery-tab]').forEach(tab => {
        tab.addEventListener('click', () => {
          if(!stageImg) return;
          stageImg.src = tab.dataset.photo;
          stageImg.removeAttribute('srcset');
          stageImg.alt = tab.dataset.alt || '';
          const single = tab.dataset.galleryTab === 'package';
          stage.dataset.single = single ? 'true' : 'false';
          if(single && packageFloat) packageFloat.hidden = true;
          if(!single && packageFloat) packageFloat.hidden = false;
          this.querySelectorAll('[data-gallery-tab]').forEach(t => t.classList.toggle('is-active', t === tab));
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
